import { Component, Input, OnDestroy, type OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import {
  IInvestmentLine,
  IPolicyAsset,
} from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import {
  previdential_change_investment_line_form_keys,
  PREVIDENTIAL_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS,
  PREVIDENTIAL_CHANGE_INVESTMENT_LINE_SITUATION_TABLE_KEYS,
} from './change-investment-line-isp.constants';

@Component({
  selector: 'app-change-investment-line-isp',
  templateUrl: './change-investment-line-isp.component.html',
  styleUrl: './change-investment-line-isp.component.scss',
})
export class ChangeInvestmentLineIspComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;
  @Input('assets')
  set _assets(val: IInvestmentLine[]) {
    if (val && val.length > 0) {
      this.manageFunds(val);
    }
  }
  assets: IInvestmentLine[] = [];
  currentLineAssets: IPolicyAsset[] = [];
  newLineAssets: IPolicyAsset[] = [];

  keys: IFormKey[] = CommonUtils.assign(
    previdential_change_investment_line_form_keys
  );
  assetsTableKeys: ITableKey[] = CommonUtils.assign(
    PREVIDENTIAL_CHANGE_INVESTMENT_LINE_ASSETS_TABLE_TABLE_KEYS
  );
  situationTableKeys: ITableKey[] = CommonUtils.assign(
    PREVIDENTIAL_CHANGE_INVESTMENT_LINE_SITUATION_TABLE_KEYS
  );
  actualInvestmentLineCode: string = '';
  actualInvestmentLineDescription: string = '';
  destroy$ = new Subject();

  ngOnInit(): void {
    this.form.controls['destinationLine'].valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: string) => {
        this.updateLineAssets(value);
      });
    if (this.form.controls['destinationLine'].value) {
      this.updateLineAssets(this.form.controls['destinationLine'].value);
    }
  }

  formatAmount(value: number | string): string {
    return value.toString().replace('.', ',');
  }

  private updateLineAssets(selectedLineCode: string): void {
    if (!selectedLineCode) {
      this.currentLineAssets = [];
      this.newLineAssets = [];
      return;
    }

    const selectedLine = this.assets.find((x) => x.code === selectedLineCode);
    const currentInvestmentLine = this.assets.find(
      (x) => x.code === this.actualInvestmentLineCode
    );

    if (!selectedLine) {
      this.currentLineAssets = [];
      this.newLineAssets = [];
      return;
    }

    this.currentLineAssets = currentInvestmentLine?.funds || [];
    this.newLineAssets = selectedLine.funds;
  }

  get destinationLineFormKey(): IFormKey {
    return this.keys.find((x) => x.controlName === 'destinationLine');
  }

  manageFunds(assets: IInvestmentLine[]) {
    this.assets = assets;
    this.actualInvestmentLineCode = assets?.find((x) => x.selected).code;
    this.actualInvestmentLineDescription =
      assets?.find((x) => x.selected).description || '';

    this.destinationLineFormKey.options = assets
      ?.filter((x) => x.code !== this.actualInvestmentLineCode)
      .map((x) => ({
        key: x.code,
        value: x.description,
      }));
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
